import instance from "../utils/network";
import { HoldemNowType, PubType } from "./types";

export type LikeType = "CAFE" | "PRODUCT";

export interface WalletPubDto {
  id: number;
  areaProvinceId: number;
  pubName: string;
  point: number;
  mileage: number;
  coverImageUrl: null | string;
  pubType: PubType;
}
export interface WalletAreaPubResponse {
  area: string;
  cafes: WalletPubDto[];
}

export interface LikeCafeRes {
  seed: number;
  area: WalletAreaPubResponse[];
}

export interface MemberHistoryResponse {
  list: MemberHistoryDto[];
  total: number;
}

export interface nearPubResponse {
  pubName: string;
  point: number;
}
export interface MemberHistoryDto {
  createdAt: string;
  pubName: string;
  tournamentTitle: string;
  entryCount: number;
  rank: number | null;
  reBuyInCount: number;
  addOnCount: number;
  totalPointsSpent: number;
  pointsWon: number;
  tournamentEntry: number;
  pubType: PubType;
  totalEntry: number;
  rankPoint: number;
  id: number;
}
export interface GetRankResponse {
  rankings: RankDto[];
  myRank: RankDto | null;
  total: number;
}
export interface RankDto {
  nickname: string;
  rank: number;
  tier: string;
  points: number;
  memberId: number;
  userId: number;
  id: number;
  pubId: number;
  seasonNumber: number;
  pubName: string;
}

export function getRanking(id: number): Promise<GetRankResponse> {
  return instance.get(`/member/ranking/${id}`);
}

export function getWalletItems(): Promise<WalletAreaPubResponse[]> {
  return instance.get("/nest/member/list");
}

export enum PointLogType {
  TOURNAMENT_ENTRY = "TOURNAMENT_ENTRY", // 토너먼트 참가
  TOURNAMENT_REFUND = "TOURNAMENT_REFUND", //토너먼트 환불
  TOURNAMENT_RESULT = "TOURNAMENT_RESULT", // 토너먼트 결과
  TOURNAMENT_RESULT_CANCEL = "TOURNAMENT_RESULT_CANCEL", // 토너먼트 결과 취소
  ADMIN_TOURNAMENT_RESULT = "ADMIN_TOURNAMENT_RESULT", // 관리자 토너먼트 결과
  ADMIN_TOURNAMENT_RESULT_CANCEL = "ADMIN_TOURNAMENT_RESULT_CANCEL", // 관리자 토너먼트 결과 취소
  ADMIN_ADJUSTMENT = "ADMIN_ADJUSTMENT", // 관리자 조정
  WITHDRAWAL = "WITHDRAWAL", // 토너 포인트 회수
  TOURNAMENT_REWARD = "TOURNAMENT_REWARD", // 토너 시상
  TOURNAMENT_REWARD_CANCEL = "TOURNAMENT_REWARD_CANCEL", // 토너 시상 취소
  RESERVATION = "RESERVATION", // 예약
  RESERVATION_CANCEL = "RESERVATION_CANCEL", // 예약 취소
  RESERVATION_DISCOUNT = "RESERVATION_DISCOUNT", // 예약 할인 환불
  RESERVATION_DISCOUNT_CANCEL = "RESERVATION_DISCOUNT_CANCEL", // 예약 할인 환불 취소
  DEPOSIT = "DEPOSIT",
  DEPOSIT_CANCEL = "DEPOSIT_CANCEL",
  PROMOTION = "PROMOTION",
  PROMOTION_CANCEL = "PROMOTION_CANCEL",
}

export enum MemberMileageLogType {
  CASH = "CASH",
  BANK = "BANK",
  CARD = "CARD",
  BUY = "BUY",
  CASH_CANCEL = "CASH_CANCEL",
  BANK_CANCEL = "BANK_CANCEL",
  CARD_CANCEL = "CARD_CANCEL",
  BUY_CANCEL = "BUY_CANCEL",
  MANUAL_CHARGE = "MANUAL_CHARGE",
  MANUAL_CHARGE_CANCEL = "MANUAL_CHARGE_CANCEL",
  EXPIRES = "EXPIRES",
}
export interface PointLogDto {
  createdAt: Date;
  point: number;
  actionType: PointLogType;
  pubName: string;
}

export interface MileageLogDto {
  date: string;
  type: MemberMileageLogType;
  menu: string;
  point: number;
  pubName: string;
  expiredAt: Date;
}

export interface MileageHistoryResponse {
  date: string;
  list: MileageLogDto[];
}
export interface PointHistoryResponse {
  date: string;
  list: PointLogDto[];
}

export function myPoint(pubId: number): Promise<number> {
  return instance.get(`/nest/member/member-point/${pubId}`);
}

export function myMileage(pubId: number): Promise<number> {
  return instance.get(`/nest/member/mileage/${pubId}`);
}

export function myNearPubPoint(
  lat: number,
  lon: number,
): Promise<nearPubResponse> {
  return instance.get(`/nest/member/nearest-pub`, {
    params: { lat, lon },
  });
}

export function myMileageLog(
  year: number,
  month: number,
  pubId: number,
): Promise<MileageHistoryResponse[]> {
  return instance.get(`/nest/member/mileage-log/${pubId}`, {
    params: { year, month },
  });
}

export function myPointLog(
  year: number,
  month: number,
  pubId: number,
): Promise<PointHistoryResponse[]> {
  return instance.get(`/nest/member/member-point-log/${pubId}`, {
    params: { year, month },
  });
}

export function getHistoryItems(
  page: number,
  limit: number,
): Promise<MemberHistoryResponse> {
  return instance.get(`/nest/member/history?page=${page}&limit=${limit}`);
}

export function likeHasItems(pubId: number): Promise<{
  isMember: boolean;
}> {
  return instance.get(`/nest/member/is-member/${pubId}`);
}

export function likeAdd(pubId: number) {
  return instance.post(`/nest/member/${pubId}`);
}

export function likeDelete(pubId: number) {
  return instance.delete(`/nest/member/${pubId}`);
}

export function cafeViewMessage(params: {
  messageId: number;
}): Promise<HoldemNowType> {
  return instance.get("/cafe/viewMessage", { params });
}
